import cn from '@/lib/cs';
import React from 'react';

const IdeaIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="m14.7 5.6 1.4 1.1 1.2 1.4c.6 1 .9 2 .9 3v2.3c0 .6 0 1.2-.3 1.8-.4.8-1 1.5-1.8 2l-.9.5v1c.1.6-.4 1-1 1H9.8a1 1 0 0 1-1-.9v-1.1c-1.2-.8-2.1-2-2.5-3.4-.6-1.5-.5-3 .1-4.3l.2-.3.3-.7c.4-1 1-2 1.9-2.7l.7-.6 5.3-.1Zm-.6 15.5.4 1.2c.1.4 0 .9-.2 1.2l-.7.5h-.9l-1.5-.3a1 1 0 0 0-.4 0 1 1 0 0 1-1.1-1.1v-.3c0-.8.8-1.3 1.6-1.1l.6.1h.2l2-.2Zm7-10 .9-.4h1.3c.5 0 .8.6.8 1a1 1 0 0 1-1.3 1.1h-.1a1 1 0 0 0-.6 0H22a.9.9 0 0 1-1.1-1l.1-.7Zm-20.8 0 1-.4h1.2c.6 0 1 .6 1 1A1 1 0 0 1 2 12.9a1 1 0 0 0-.6 0h-.1a.9.9 0 0 1-1.1-1v-.7ZM13 .3l.4 1v1.2a1 1 0 1 1-2.1-.5v-.7a.9.9 0 0 1 1-1.1h.7ZM4.4 3l1 .4c.2 0 .5.3.7.5l.2.4c.3.4.2 1-.2 1.4a1 1 0 0 1-1.7-.3A1 1 0 0 0 4 5a1 1 0 0 1-.1-1.7l.5-.3ZM18 5.5a1 1 0 0 1-.2-1l.2-.4c.1-.3.3-.6.6-.7l.3-.2c.5-.3 1-.3 1.4.1.5.5.4 1.4-.2 1.7H20a1 1 0 0 0-.4.4 1 1 0 0 1-1.6.1Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default IdeaIcon;
